import { Box, CssBaseline, useTheme } from '@mui/material'
import React, { memo, useState } from 'react'
import InverterTable from '../../../../../../components/inverter/InverterTable'
import AppModal from '../../../../../../components/AppModal'

function OutputLog({ onRefreshData, onChangeValueOF1, onChangeValueOF2, ValueOf1, ValueOf2, TableHead, TableData }) {
    const { spacing } = useTheme()
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>
                <InverterTable onFullScreen={handleOpen} onRefreshData={onRefreshData} TableData={TableData} onChangeValueOF2={onChangeValueOF2} onChangeValueOF1={onChangeValueOF1} ValueOf1={ValueOf1} ValueOf2={ValueOf2} TableName={'OutputLog'} TableHead={TableHead} />
                <AppModal
                    open={open}
                    handleClose={handleClose}
                >
                    <InverterTable onRefreshData={onRefreshData} TableData={TableData} onChangeValueOF2={onChangeValueOF2} onChangeValueOF1={onChangeValueOF1} ValueOf1={ValueOf1} ValueOf2={ValueOf2} TableName={'OutputLog'} TableHead={TableHead} />
                </AppModal>
            </Box>
        </>
    )
}

export default memo(OutputLog)
